import { ATTACHMENT_TRANSFER } from '@/datasets/attachments/constants';
import { findRequest } from '../../state/state';

const findRequestAttachments = ({ requests }, { category, code }) => {
  const item = findRequest({ requests }, { category, code });
  return { item, attachments: item?.steps?.attachments, filters: item?.steps?.attachments?.filters };
};

export const allowAttachmentSelection = (attachment) => (
  [ATTACHMENT_TRANSFER.recommended.name, ATTACHMENT_TRANSFER.optional.name].includes(attachment?.metadata?.transferable)
);

/**
 * Marks attachments as selected based on the selectedObject. Does not mutate the original attachments.
 * @param {Array<Attachment>} attachments list of attachments
 * @param {Object<string, true>} selectedObject object with keys as attachments ids and values as true if selected
 * @returns {Array<Attachment>} list of attachments with selected property set to true if the attachment is selected
 */
export const selectAttachment = ({ results, selectedInitially }) => results?.map(
  (item) => ({ ...item, selected: selectedInitially?.[item.id] === true }),
) || [];

export default findRequestAttachments;
